var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { id: "connectModal", "hide-header": true, "hide-footer": true },
      model: {
        value: _vm.showConnectModal,
        callback: function($$v) {
          _vm.showConnectModal = $$v
        },
        expression: "showConnectModal"
      }
    },
    [
      _vm.targetConnectModal == "endo"
        ? _c("div", { attrs: { id: "modalEndo" } }, [
            !_vm.confirmEndomondo
              ? _c("div", { attrs: { id: "endo" } }, [
                  _c("div", { staticClass: "endomondo-header" }, [
                    _c("div", { staticClass: "endomondo-logo" })
                  ]),
                  _c(
                    "div",
                    { staticClass: "connectForm" },
                    [
                      _c(
                        "b-form",
                        { on: { submit: _vm.doEndo } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "email-group",
                                label: _vm.$t("signin.form.email"),
                                "label-for": "email"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "email",
                                  type: "email",
                                  required: ""
                                },
                                model: {
                                  value: _vm.endomondoForm.username,
                                  callback: function($$v) {
                                    _vm.$set(_vm.endomondoForm, "username", $$v)
                                  },
                                  expression: "endomondoForm.username"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "password",
                              attrs: {
                                id: "password-group",
                                label: _vm.$t("signin.form.pwd"),
                                "label-for": "password"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "password",
                                  type: "password",
                                  required: ""
                                },
                                model: {
                                  value: _vm.endomondoForm.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.endomondoForm, "password", $$v)
                                  },
                                  expression: "endomondoForm.password"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { id: "acceptance", name: "acceptance" },
                              model: {
                                value: _vm.endomondoForm.rememberPass,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.endomondoForm,
                                    "rememberPass",
                                    $$v
                                  )
                                },
                                expression: "endomondoForm.rememberPass"
                              }
                            },
                            [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "register.form.virtual.auth.remember"
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm.authError
                            ? _c("div", { staticClass: "clearfix" }, [
                                _c("div", {
                                  staticClass: "errorMsg",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("register.form.virtual.auth.error")
                                    )
                                  }
                                })
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "clearfix" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-auth endo",
                                  attrs: {
                                    disabled: _vm.connectingTracker,
                                    block: "",
                                    type: "submit"
                                  }
                                },
                                [
                                  _vm.connectingTracker
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.form.virtual.auth.login"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "clearfix" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-reset",
                                  attrs: {
                                    block: "",
                                    href:
                                      "https://www.endomondo.com/forgotpassword",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("register.form.virtual.auth.reset")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "clearfix" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-signup",
                                  attrs: {
                                    block: "",
                                    href: "https://www.endomondo.com/signup",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "register.form.virtual.auth.signup"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.confirmEndomondo
              ? _c("div", { attrs: { id: "endoConfirm" } }, [
                  _c("div", { staticClass: "endomondo-header" }, [
                    _c("div", { staticClass: "endomondo-logo" })
                  ]),
                  _c(
                    "div",
                    { staticClass: "accountDetails" },
                    [
                      _c("img", {
                        staticClass: "avatar",
                        attrs: {
                          src: _vm.endomondoProfile.data.data.avatar_url
                        }
                      }),
                      _c("p", { staticClass: "username" }, [
                        _vm._v(
                          _vm._s(_vm.endomondoProfile.data.data.first_name) +
                            " " +
                            _vm._s(_vm.endomondoProfile.data.data.last_name)
                        )
                      ]),
                      _c("p", { staticClass: "email" }, [
                        _vm._v(_vm._s(_vm.endomondoProfile.data.data.email))
                      ]),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-auth endo",
                          attrs: { block: "", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.confirmConnection("endomondo")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("register.form.virtual.auth.confirm")
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-reset",
                          attrs: { block: "", type: "button" },
                          on: { click: _vm.cancelConnection }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("register.form.virtual.auth.change"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.accountDuplicate
                    ? _c("div", { staticClass: "clearfix" }, [
                        _c("div", {
                          staticClass: "errorMsg",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "register.form.virtual.auth.errorDuplicate"
                              )
                            )
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm.targetConnectModal == "garmin"
        ? _c("div", { attrs: { id: "modalGarmin" } }, [
            !_vm.confirmGarmin
              ? _c("div", { attrs: { id: "garmin" } }, [
                  _c("div", { staticClass: "garmin-header" }, [
                    _c("div", { staticClass: "garmin-logo" })
                  ]),
                  _c(
                    "div",
                    { staticClass: "connectForm" },
                    [
                      _c(
                        "b-form",
                        { on: { submit: _vm.doGarmin } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "email-group",
                                label: _vm.$t("signin.form.email"),
                                "label-for": "email"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "email",
                                  type: "text",
                                  required: ""
                                },
                                model: {
                                  value: _vm.garminForm.username,
                                  callback: function($$v) {
                                    _vm.$set(_vm.garminForm, "username", $$v)
                                  },
                                  expression: "garminForm.username"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "password",
                              attrs: {
                                id: "password-group",
                                label: _vm.$t("signin.form.pwd"),
                                "label-for": "password"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "password",
                                  type: "password",
                                  required: ""
                                },
                                model: {
                                  value: _vm.garminForm.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.garminForm, "password", $$v)
                                  },
                                  expression: "garminForm.password"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { id: "acceptance", name: "acceptance" },
                              model: {
                                value: _vm.garminForm.rememberPass,
                                callback: function($$v) {
                                  _vm.$set(_vm.garminForm, "rememberPass", $$v)
                                },
                                expression: "garminForm.rememberPass"
                              }
                            },
                            [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "register.form.virtual.auth.remember"
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm.authError
                            ? _c("div", { staticClass: "clearfix" }, [
                                _c("div", {
                                  staticClass: "errorMsg",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("register.form.virtual.auth.error")
                                    )
                                  }
                                })
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "clearfix" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btn-auth garmin",
                                  attrs: {
                                    disabled: _vm.connectingTracker,
                                    block: "",
                                    type: "submit"
                                  }
                                },
                                [
                                  _vm.connectingTracker
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.form.virtual.auth.login"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.confirmGarmin
              ? _c("div", { attrs: { id: "garminConfirm" } }, [
                  _c("div", { staticClass: "garmin-header" }, [
                    _c("div", { staticClass: "garmin-logo" })
                  ]),
                  _c(
                    "div",
                    { staticClass: "accountDetails" },
                    [
                      _c("p", { staticClass: "username" }, [
                        _vm._v(_vm._s(_vm.garminProfile.data.data.displayName))
                      ]),
                      _c("p", { staticClass: "email" }, [
                        _vm._v(_vm._s(_vm.garminProfile.data.data.emailAddress))
                      ]),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-auth garmin",
                          attrs: { block: "", type: "submit" },
                          on: {
                            click: function($event) {
                              return _vm.confirmConnection("garmin")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("register.form.virtual.auth.confirm"))
                          )
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-reset",
                          attrs: {
                            block: "",
                            type: "submit",
                            target: "_blank"
                          },
                          on: { click: _vm.cancelConnection }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("register.form.virtual.auth.change"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.accountDuplicate
                    ? _c("div", { staticClass: "clearfix" }, [
                        _c("div", {
                          staticClass: "errorMsg",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "register.form.virtual.auth.errorDuplicate"
                              )
                            )
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ConnectModal.vue?vue&type=template&id=5a6a7e93&
// module id = 882
// module chunks = 0